import {z} from 'zod';

export default z.object({
    style: z.enum(['ordered', 'unordered']),
    items: z.array(z.string())
});
